import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RouterRoutes,
} from "react-router-dom";
import ThemedToastContainer from "../components/ThemedToastContainer";

import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import Teams from "../pages/Teams";
import Departments from "../pages/Departments";
import ZernioContas from "../pages/Zernio";
import ModelosWhatsapp from "../pages/ModelosWhatsapp";
import ZernioPublicacoes from "../pages/Zernio/Publicacoes";
import ZernioComentarios from "../pages/Zernio/Comentarios";
import ZernioMencoes from "../pages/Zernio/Mencoes";
import ZernioAvaliacoes from "../pages/Zernio/Avaliacoes";
import ZernioAnalises from "../pages/Zernio/Analises";
import ZernioAnuncios from "../pages/Zernio/Anuncios";
import ScheduledMessages from "../pages/ScheduledMessages";
import MediaLibrary from "../pages/MediaLibrary";
import Campaigns from "../pages/Campaigns/";
import Kanban from "../pages/Kanban";
import InternalChat from "../pages/InternalChat";
import Flows from "../pages/Flows";
import FlowBuilder from "../pages/FlowBuilder";
import Reports from "../pages/Reports";
import Plans from "../pages/Plans";
import Companies from "../pages/Companies";
import Invoices from "../pages/Invoices";
import Billing from "../pages/Billing";
import QueueIntegrations from "../pages/QueueIntegrations";
import MessagesApi from "../pages/MessagesApi";
import Helps from "../pages/Helps";
import CampaignsPhrases from "../pages/CampaignsPhrases";
import CampaignsConfig from "../pages/CampaignsConfig";
import GlobalConfig from "../pages/GlobalConfig";
import CompanySubscription from "../pages/CompanySubscription";
import Modules from "../pages/Modules";
import Roles from "../pages/Roles";
import AiHub from "../pages/AiHub";
import OperationalPanel from "../pages/OperationalPanel";
import ContactTimeline from "../pages/ContactTimeline";
import TicketReplay from "../pages/TicketReplay";
import SaasFinance from "../pages/SaasFinance";
import Commercial from "../pages/Commercial";
// import MetaHub from "../pages/MetaHub"; // reativar junto com a rota /meta
import Announcements from "../pages/Announcements";
import ContactLists from "../pages/ContactLists";
import { AuthProvider } from "../context/Auth/AuthContext";
import { ThemeProvider } from "../context/DarkMode";
import { WhiteLabelProvider } from "../context/WhiteLabel";
import { PrivateRoutes, PublicRoute } from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <WhiteLabelProvider>
          <RouterRoutes>
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
            </Route>
            <Route element={<PrivateRoutes />}>
              <Route index element={<Dashboard />} />
              <Route path="/tickets/:ticketId?" element={<Tickets />} />
              <Route path="/connections" element={<Connections />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route
                path="/contacts/:contactId/timeline"
                element={<ContactTimeline />}
              />
              <Route
                path="/tickets/:ticketId/replay"
                element={<TicketReplay />}
              />
              <Route path="/users" element={<Users />} />
              <Route path="/roles" element={<Roles />} />
              <Route path="/ai" element={<AiHub />} />
              <Route path="/quickAnswers" element={<QuickAnswers />} />
              <Route path="/Settings" element={<Settings />} />
              <Route path="/Queues" element={<Queues />} />
              <Route path="/tags" element={<Tags />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/departments" element={<Departments />} />
              {/* A Central de Webhooks foi para /messages-api, junto da API
                  REST: as duas pontas da integração moram na mesma tela.
                  O redirecionamento fica porque link e favorito antigos
                  continuam existindo. */}
              <Route
                path="/webhooks"
                element={<Navigate replace to="/messages-api" />}
              />
              {/* Cada assunto da Zernio é uma tela, com item próprio no menu:
                  gerenciar publicação e responder comentário são trabalhos
                  diferentes, e empilhá-los em abas escondia metade deles. */}
              <Route path="/modelos-whatsapp" element={<ModelosWhatsapp />} />
              <Route path="/zernio" element={<ZernioContas />} />
              <Route
                path="/zernio/publicacoes"
                element={<ZernioPublicacoes />}
              />
              <Route
                path="/zernio/comentarios"
                element={<ZernioComentarios />}
              />
              <Route path="/zernio/mencoes" element={<ZernioMencoes />} />
              <Route path="/zernio/avaliacoes" element={<ZernioAvaliacoes />} />
              <Route path="/zernio/analises" element={<ZernioAnalises />} />
              <Route path="/zernio/anuncios" element={<ZernioAnuncios />} />
              <Route path="/queue-integrations" element={<QueueIntegrations />} />
              <Route path="/messages-api" element={<MessagesApi />} />
              <Route path="/helps" element={<Helps />} />
              <Route path="/campaigns-phrases" element={<CampaignsPhrases />} />
              <Route path="/campaigns-config" element={<CampaignsConfig />} />
              <Route path="/global-config" element={<GlobalConfig />} />
              <Route path="/scheduled-messages" element={<ScheduledMessages />} />
              <Route path="/media-library" element={<MediaLibrary />} />
              <Route path="/campaigns" element={<Campaigns />} />
              {/* O Kanban é o quadro único. Os endereços das telas que ele
                  substituiu continuam valendo — link salvo, favorito — e
                  levam para cá. */}
              <Route path="/kanban" element={<Kanban />} />
              <Route
                path="/quadros"
                element={<Navigate replace to="/kanban" />}
              />
              <Route
                path="/crm/leads"
                element={<Navigate replace to="/kanban" />}
              />
              <Route
                path="/crm/funnel"
                element={<Navigate replace to="/kanban" />}
              />
              <Route path="/boards" element={<Navigate replace to="/kanban" />} />
              <Route path="/internal-chat" element={<InternalChat />} />
              {/* Facebook e Instagram agora entram pela tela de Conexões,
                  como conexão de canal — a tela /meta segue fora do ar. */}
              {/* <Route path="/meta" element={<MetaHub />} /> */}
              <Route path="/flows" element={<Flows />} />
              <Route path="/flows/:flowId/edit" element={<FlowBuilder />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/operational-panel" element={<OperationalPanel />} />
              <Route path="/saas/finance" element={<SaasFinance />} />
              <Route path="/saas/commercial" element={<Commercial />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/financeiro" element={<Billing />} />
              <Route
                path="/companies/:companyId/subscription"
                element={<CompanySubscription />}
              />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/contact-lists" element={<ContactLists />} />
              {/* No router 5 o <Switch> caía no layout mesmo sem rota casada;
                  no 7 sobraria tela em branco. */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </RouterRoutes>
          <ThemedToastContainer />
          </WhiteLabelProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
